<div class="ui-g-12" [hidden]="_activatedRoute.children.length > 0">
    <div class="row p-1">
        <div class="col-12 pageTitle">
            <h2>&nbsp;&nbsp;&nbsp;{{ title }} - Reports</h2>  <p-button label="Back" (click)="back()" style="float:right"></p-button>
        </div>
       
        </div>
        <p-dialog [(visible)]="popupDisplayReportsParams"
                  [draggable]="true"
                  [modal]="true"
                  positionType="absolute"
                  [style]="{ width: '25vw' }"
                  [baseZIndex]="10000"
                  [maximizable]="true">
            <p-header> Report Parameter Details </p-header>

            <div class="grid">
                <div class="col-12">
                    <app-reports-view-params #reportsViewParams
                                             (btnOpenReport_Clicked)="onReportViewParam_Click($event)"></app-reports-view-params>
                </div>
            </div>
            <p-footer style="display: flex; justify-content: center"> </p-footer>
        </p-dialog>
    </div>

<div [hidden]="_activatedRoute.children.length === 0">
  <div class="mt-2">
    <p-button label="Back" (click)="back()"></p-button>
    <hr />
  </div>
  <router-outlet></router-outlet>
</div>
